module.exports = __webpack_public_path__ + "media/src/images/icons/arrow_up_no_fill-6a9aff7bcb0f9b6152c8a833e6dc8507.svg";